export default __webpack_public_path__ + "static/media/cloud-network.04fb45df.svg";